module.exports = __webpack_public_path__ + "static/media/liftingMethod2.2173e020.png";